const AlertBar = () => {
  const alertBar = document.getElementById('e29-alert-bar');

  if ( !alertBar ) return;

  if ( sessionStorage.getItem('e29-alert-bar') ) {
    alertBar.remove();
  } else {
    alertBar.removeAttribute('style');
    alertBar.querySelector('.alert-bar__close').addEventListener('click', () => {
      sessionStorage.setItem('e29-alert-bar', 'true');
      alertBar.remove();
    });
  }
}

export default AlertBar;
